var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Arrow/Default/"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59992 2.40047C7.59992 2.1793 7.77901 2 7.99992 2C8.22083 2 8.39992 2.1793 8.39992 2.40047L8.39992 13.0462C8.4082 13.0388 8.41633 13.0311 8.42428 13.0231L12.3838 9.05887C12.5401 8.90248 12.7933 8.90248 12.9495 9.05887C13.1057 9.21527 13.1057 9.46883 12.9495 9.62523L8.98997 13.5895C8.44323 14.1368 7.5568 14.1368 7.01007 13.5895L3.05051 9.62523C2.8943 9.46883 2.8943 9.21527 3.05051 9.05887C3.20672 8.90248 3.45998 8.90248 3.61619 9.05887L7.57575 13.0231C7.58365 13.031 7.59171 13.0387 7.59992 13.046L7.59992 2.40047Z",
    fill: "#ffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.f9fcb1cafd6f0eb0682c613f859e016f.svg";
export { ForwardRef as ReactComponent };